import React, { useEffect, useState } from 'react';
import { apiFetch } from '../config/api';
import { useIdioma } from '../i18n';

/**
 * Créditos de IA restantes, no topo das telas autenticadas.
 *
 * Este componente existia e não compilava: importava `../services/aiService`, e
 * `src/services/` nunca existiu no frontend. Ou seja, ele nunca foi usado por
 * tela nenhuma — a primeira tentativa de importá-lo derrubou o build. É o mesmo
 * padrão do `page_crawler.rs` e do `aiContext.js`: arquivo que parece vivo e é
 * inerte.
 *
 * Passou a consumir `/ai/credits` direto, que é a rota que a tela de
 * otimizações já usava.
 *
 * Some quando não há resposta em vez de mostrar erro: é informação de apoio no
 * canto do cabeçalho, e um aviso de falha ali competiria com o conteúdo da
 * página por atenção que ele não merece.
 */
const AICreditsDisplay = () => {
  const { t } = useIdioma();
  const [creditos, setCreditos] = useState(null);

  useEffect(() => {
    let ativo = true;

    apiFetch('/ai/credits')
      .then((r) => (r.ok ? r.json() : null))
      .then((json) => {
        if (ativo && json) setCreditos(json);
      })
      .catch(() => {});

    return () => {
      ativo = false;
    };
  }, []);

  if (!creditos) return null;

  const restantes = creditos.credits_remaining ?? 0;
  const total = creditos.total_credits ?? 0;

  return (
    <span className="app-credits" title={t('conta.plano', { plano: creditos.plan })}>
      <b>{restantes}</b>
      <span>{t('menu.creditosSufixo', { total })}</span>
    </span>
  );
};

export default AICreditsDisplay;
